// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__xMq9z","total":"Cart_total__jPKou","actions":"Cart_actions__3L7-N","button--alt":"Cart_button--alt__16K_Z","button":"Cart_button__39fUp"};